module.exports = __webpack_public_path__ + "assets/unlock-feature.svg";